import { CreateCompanyDto, FormCompanyDto, OptionDto, RowCompanyDto } from "@/dtos";
import { City, Company } from "@/entities";
import { getStatusOption, getStatusCompany } from "@/helpers/options/fleet-management/company/company-status";
import { CompanyStatus, ContactType } from "@/helpers/types";

export const formatRowCompanyDto = async (companies: Company[]): Promise<RowCompanyDto[]> => {
    const result = [] as RowCompanyDto[];
    companies.map((x) => {
        const tableCompanyDto: RowCompanyDto = {
            ...x,
            identification: (x.identification) ? x.identification : 'SN',
            email: x.contact?.find((x) => x.type == ContactType.EMAIL)?.identification ?? '',
            cellphone: x.contact?.find((x) => x.type == ContactType.CELLPHONE)?.identification ?? '',
            status: (x.status) ? getStatusCompany(parseInt(x.status)) : CompanyStatus.WORKING,
            status_label: (x.status) ? getStatusOption(parseInt(x.status)).label : '',
            active: x.is_active ? 'Activo' : 'Inactivo',
            city_label: x.city?.name ?? ''
        }
        result.push(tableCompanyDto);
    });

    return result;
}

export const formatCompanyDto = async (formCompany: FormCompanyDto): Promise<CreateCompanyDto> => {
    const contacts = [
        {
            type: ContactType.CELLPHONE,
            identification: formCompany.cellphone,
            alias: formCompany.alias_cellphone,
            is_validate: false
        },
        {
            type: ContactType.EMAIL,
            identification: formCompany.email,
            alias: formCompany.alias_email,
            is_validate: false
        }
    ]

    const city = { id: formCompany.city_id } as City;

    const companyDto: CreateCompanyDto = {
        name: formCompany.name,
        address: formCompany.address,
        identification: formCompany.identification,
        contact: JSON.parse(JSON.stringify(contacts)),
        latitude: formCompany.latitude,
        longitude: formCompany.longitude,
        status: getStatusOption(formCompany.status).value,
        city: city,
        system_id: 1
    }

    return companyDto;
}

export const formatOptionsCompany = (companies: Company[]): OptionDto[] => {
    return companies.map((x) => {
        const opt: OptionDto = {
            label: x.name,
            value: x.id
        }
        return opt;
    });
}
